import { useGenerateLinkMutation } from 'src/services/links';
import { GenerateLinkResponse, LinkType } from 'src/services/links/generateLink';

const useDynamicLinks = () => {
  const [generateLink] = useGenerateLinkMutation();

  const createDynamicLink = async ({ id, targetType }: { id: string | number | (string | number)[], targetType: LinkType }): Promise<string | undefined> => {

    try {
      const response: GenerateLinkResponse | any = await generateLink({
        target_type: targetType,
        target_id: String(id),
      });

      if ('error' in response) {
        throw new Error(response.error);
      }

      return response?.data?.data?.url as string;
    } catch (error) {
      console.error('Error creating dynamic link:', error);
      throw error;
    }
  };

  return {
    createDynamicLink,
  };
};

export default useDynamicLinks;
